import { useLocation } from 'react-router';
import { useRef } from 'react';
import equal from 'fast-deep-equal';
import type { FetcherState, FilterType, QueryParams } from './types';
import { getStoredState, setStoredState } from './storage';
import { serializeQs } from './useQueryState';

type FetcherParams = {
  pageSize?: number;
  defaultPageSize?: number;
  queryParams?: QueryParams;
  defaultFilter?: FilterType;
  storageKey?: string;
};

type Fetcher = {
  initialState: FetcherState;
  onStateChange?: (state: FetcherState) => void;
  defaultFilter: FilterType;
  navigateTo?: string;
};

const defaultDefualtFilter = {};

export function useFetcher(params: FetcherParams): Fetcher {
  const {
    pageSize: constantPageSize,
    defaultPageSize = 15,
    defaultFilter = defaultDefualtFilter,
    storageKey,
    queryParams,
  } = params;

  const initialState: FetcherState = {
    pageIndex: 1,
    pageSize: constantPageSize || defaultPageSize,
    filter: defaultFilter,
    sort: undefined,
    queryParams,
  };

  const location = useLocation();
  const restoredRef = useRef<any>(null);
  let navigateTo;
  if (storageKey && restoredRef.current !== storageKey && !location.search) {
    restoredRef.current === storageKey;
    const restoredState = getStoredState(storageKey);
    if (restoredState) {
      navigateTo = `${location.pathname}${serializeQs({
        ...initialState,
        ...restoredState,
        filter: {
          ...initialState.filter,
          ...restoredState?.filter,
        },
      })}`;
    }
  }

  // write back to storage when state changes
  const onStateChange = storageKey
    ? (state: FetcherState) => setStoredState(storageKey, equal(state, initialState) ? undefined : state)
    : undefined;

  return {
    initialState,
    defaultFilter,
    onStateChange,
    navigateTo,
  };
}
